import { Stepper } from "@/components";
import { STEPPER } from "@/components/Styles/variants";
import polyglot from "@/utils/polyglot";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import StepTitle from "../categoryForms/common/StepTitle";
import { StyledFormControl } from "../categoryForms/common/fields";

const PricePerHourSelection = ({ title, data }) => {
  const { setFieldValue, values } = useFormikContext();

  const {
    price_per_hour_recommended = 10,
    price_per_hour_min,
    price_per_hour_max,
  } = data?.categories?.find(
    ({ category_id }) => category_id === values.category
  ) || {};

  useEffect(() => {
    if (!values.price_per_hour) {
      setFieldValue("price_per_hour", price_per_hour_recommended);
    }
  }, [values.price_per_hour]);

  return (
    <>
      <StepTitle>{title}</StepTitle>
      <StyledFormControl>
        <Stepper
          size={STEPPER.SIZE.LARGE}
          value={values.price_per_hour}
          min={price_per_hour_min}
          max={price_per_hour_max}
          step={1}
          onChange={(value) => setFieldValue("price_per_hour", value)}
          hint={polyglot.t("recurring_jobs.recommended_price_per_hour", {
            price_per_hour: polyglot.toSmartCurrency(
              price_per_hour_recommended,
              { pricePerHour: true, noDecimal: true }
            ),
          })}
        >
          {(value) =>
            `${polyglot.toSmartCurrency(value, {
              pricePerHour: true,
              noDecimal: true,
            })}`
          }
        </Stepper>
      </StyledFormControl>
    </>
  );
};

export default PricePerHourSelection;
